import styled from 'styled-components';
import { Button as ButtonBase, ButtonProps } from '../../input/Button';
import { Flex, FlexProps } from '../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'BusinessRegistrationType' })
    .attrs<FlexProps>({
        direction: 'row',
        p: 2,
        borderRadius: 2,
        spacing: 2,
        backgroundColor: 'var(--control-secondary-background)',
        width: '100%',
    })``;

export const Button = styled(ButtonBase)
    .withConfig({ displayName: 'BusinessRegistrationTypeButton' })
    .attrs<ButtonProps>((props) => ({
        ...props,
        size: 'm',
        color: 'invert',
        justifySelf: 'flex-end',
    }))``;
